import { Component, OnInit, Input, ElementRef } from '@angular/core';
declare var jQuery: any;
import '../../../assets/semantic/semantic.min.js';
import { CompanyService } from '../../_services/company.service';

@Component({
  selector: 'app-company-rating',
  templateUrl: './company-rating.component.html',
  styleUrls: ['./company-rating.component.css']
})
export class CompanyRatingComponent implements OnInit {
  @Input() rating: number;
  @Input() companyId: number;

  constructor(private elRef: ElementRef, private service: CompanyService) { }

  ngOnInit() {
    jQuery(this.elRef.nativeElement).find('.rating').rating({
      initialRating: this.rating,
      maxRating: 5,
      onRate: function (value) {
        this.service.rateCompany(this.companyId, value).subscribe(response => {
          if (response !== 200) { // If the Update doesn't Works
            // Restore the Previous Rating
            jQuery(this.elRef.nativeElement).find('.rating').rating('disable');
            jQuery(this.elRef.nativeElement).find('.rating').rating('set rating', this.rating);
            jQuery(this.elRef.nativeElement).find('.rating').rating('enable');
          } else {
            // Else, update the rating stored in the Component.
            this.rating = value;
          }
        })

      }.bind(this)
    })
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/company-rating/company-rating.component.ts